export default "__VITE_ASSET__Dw32YYB$__"